import {tokens} from '@pleo-io/telescope'
import {StaticQuery, graphql} from 'gatsby'
import React, {FC} from 'react'
import styled from 'styled-components'

import Pricing from '@/components/pricing'
import {PricingSectionQuery} from '@/graphql-types'
import {useLocalizedContent} from '@/hooks/use-localized-content'
import RichText, {hasRichText, Props as RichTextProps} from '@helios/shared/components/rich-text'
import {BackgroundWrapper, Section, TitleLayout} from '@helios/shared/styles/grid'
import {PrismicData} from '@helios/shared/types/prismic-data'

type Props = {
    withCtas?: boolean
}

type PricingSectionProps = Props & {
    content: PrismicData<PricingSectionQuery, 'allPrismicPricingTiers'>
    title?: RichTextProps['content']
}

export const PricingSection: FC<PricingSectionProps> = ({title, content, withCtas}) => {
    return (
        <BackgroundWrapper color="muted">
            <SectionWrapper>
                {hasRichText(title) && (
                    <TitleLayout>
                        <RichText content={title} size="xl" as="h2" />
                    </TitleLayout>
                )}
                <Pricing withCtas={withCtas} content={content.data} />
            </SectionWrapper>
        </BackgroundWrapper>
    )
}

const PricingSectionContainer = ({
    allPrismicPricingTiers,
    ...props
}: Props & PricingSectionQuery) => {
    const [content] = useLocalizedContent(allPrismicPricingTiers.nodes)
    return <PricingSection content={content} {...props} />
}

const query = graphql`
    query PricingSection {
        allPrismicPricingTiers {
            nodes {
                lang
                ...Pricing
            }
        }
    }
`

export default function PricingSectionQueryContainer(props: Props) {
    return (
        <StaticQuery
            query={`${query}`}
            render={(data: PricingSectionQuery) => <PricingSectionContainer {...data} {...props} />}
        />
    )
}

const SectionWrapper = styled(Section)`
    display: grid;
    row-gap: ${tokens.spacing60};
`
